
export default angular.module('installer.i18n', []).
  factory('i18n', $interpolate => function factory(text, params) {
    return params ? $interpolate(text)(params) : text;
  });




// WEBPACK FOOTER //
// ./src/blocks/i18n/i18n.js